module.exports = __webpack_public_path__ + "img/تراکت-دورو.5319baac.png";